export function isEcprNumber(value: string): boolean {
    if (!/^[0-9]{6}[17][A-Z]{2}[0-9]$/.test(value)) return false;

    const day = parseInt(value.substring(0, 2));
    const month = parseInt(value.substring(2, 4));
    const year = parseInt(value.substring(4, 6));
    const century = value[6] === '1' ? 1900 : 2000;
    if (month < 1 || month > 12) return false;

    // Date uses zero-based months, so day 0 with our one-based month
    // gives the last day of the requested month.
    const daysInMonth = new Date(century + year, month, 0).getDate();
    return day >= 1 && day <= daysInMonth;
}
